module.exports = __webpack_public_path__ + "img/banner.5425d31b.png";